import { yupResolver } from "@hookform/resolvers/yup";
import * as Mui from "@mui/material";
import { AxiosError } from "axios";
import { useContext, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import SectionHeader from "../../../../util/component/SectionHeader";
import { ContextOperation } from "../../context/OperationContext";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import useSnackbar from "../../hooks/useSnackbar";
import OperationTypes from "../../types";
import GeneralInfoStep from "./GeneralInfoStep";
import VehiclesStep from "./VehiclesStep";
import VehicleTransferService, { ICheckOutDdtListRequest } from "./service/VehicleTransferService";

const schema = yup.object().shape({
  checkOutDdtListRequest: yup.array().of(
    yup.object().shape({
      vin: yup.string().required("Plate is required"),
    })
  ),
});
export const VehicleTransferForm = () => {
  const { tenant, setLoading } = useContext(ContextOperation);
  const t = useOperationTranslation();
  const snackbar = useSnackbar();
  const form = useForm<ICheckOutDdtListRequest>({
    //shouldUnregister:false,
    defaultValues: {
      checkOutDdtListRequest: [{ vin: "", ddtRequest: {} }],
    },
    resolver: yupResolver(schema),
  });

  //lere per momentin
  const handleReset = () => {
    setActiveStep(0);
    form.reset();
  };

  const onSubmit = (data: ICheckOutDdtListRequest) => {
    createCheckOutDdtListRequest(tenant, data);
  };

  ///

  function createCheckOutDdtListRequest(
    tenant: string,
    data: ICheckOutDdtListRequest
  ) {
    setLoading(true);
    VehicleTransferService.put
      .createCheckoutDdt(tenant, data)
      .then((response: any) => {
        if (response) console.log("dat");
        snackbar.show("success", t("vehicleTransfer.messages.success"));
        setLoading(false);
        setActiveStep(0);
        form.reset();
      },
      (reject: AxiosError<OperationTypes.AxiosErrorResponse>) => {
        setLoading(false);
        if (reject.response?.status === 400 && reject.response?.data.subCode === 10) {
          snackbar.show("error", t("vehicleTransfer.messages.400ErrorSubCode10"));
        }
        else if (reject.response?.status === 400) {
          snackbar.show("error", t("vehicleTransfer.messages.400Error"));
        }
        else {
          snackbar.show("error", t("vehicleTransfer.messages.500Error"));
        }
      }
    )
  }
  const [activeStep, setActiveStep] = useState<number>(0);
  function getSteps() {
    return [
      t("vehicleTransfer.generalInfo.title"),
      t("vehicleTransfer.vehicles.title"),
    ];
  }

  const steps = getSteps();
  function getStepsContent(stepIndex: any) {
    switch (stepIndex) {
      case 0:
        return <GeneralInfoStep handleNext={handleNext} tenant={tenant} />;
      case 1:
        return <VehiclesStep handleBack={handleBack} tenant={tenant} />;
    }
  }

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <div>
      <SectionHeader
          title={t("vehicleTransfer.firstTitle") + " " + t("vehicleTransfer.secondTitle")}
          subtitle={t("vehicleTransfer.subtitle")}
      />
      <Mui.Box ml={2} mr={2} mt={2}>
        <Mui.Stepper activeStep={activeStep}>
          {steps.map((label) => (
            <Mui.Step key={`step-item-${label}`} sx={{ width: "50%" }}>
              <Mui.StepLabel>{label}</Mui.StepLabel>
            </Mui.Step>
          ))}
        </Mui.Stepper>
      </Mui.Box>
      <div>
        <br />
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <Mui.Box ml={2} mr={2}>
              {getStepsContent(activeStep)}
            </Mui.Box>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};
